<app-globe #globe
(onSeeAreaClick)="onSeeAreaClick($event)"
(loadingComplete)="onGlobeLoadingComplete($event)"
(measurementDataLoad)="onMeasurementDataLoad($event)"

></app-globe>
<app-filter
    #filter
    *ngIf="marisData"
    [sampleCount]="globe.sampleCount"
    [measureCount]="globe.measureCount"
    class="filter-container"
    (onShapeTypeChanged)="onShapeTypeChanged($event)"
    [ngClass]="{ fullscreen: fullscreen }"
    [marisData]="marisData"
    (filterChanged)="onFilterChanged($event)"
    [measurementData]="measurementData"
    (summaryStatisticsChange)="onSummaryStatisticsChange($event)"
></app-filter>
<app-loading class="loading-container" [ngClass]="{ fullscreen: fullscreen }"></app-loading>

<div id="loading" *ngIf="showSpinner">
    <div class="container">
        <svg viewBox="0 0 100 100">
            <defs>
                <filter id="shadow">
                    <feDropShadow dx="0" dy="0" stdDeviation="1.5" flood-color="#3561ce" />
                </filter>
            </defs>
            <circle class="spinner" style="fill: transparent; stroke: #3561ce; stroke-width: 7px; stroke-linecap: round; filter: url(#shadow)" cx="50" cy="50" r="45" />
        </svg>
    </div>
</div>
